import React, { useEffect, useRef } from 'react';
import mermaid from 'mermaid';
import styled from 'styled-components';

const DiagramContainer = styled.div`
  margin: 20px 0;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  min-height: 200px;
`;

const DirectMermaidDiagram = ({ chart, config = {} }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!chart || !containerRef.current) return;

    console.log('DirectMermaidDiagram: Rendering chart:', chart);

    try {
      // Initialize mermaid
      mermaid.initialize({
        startOnLoad: false,
        theme: 'default',
        securityLevel: 'loose',
        ...config
      });

      // Clear container
      containerRef.current.innerHTML = '';
      
      // Generate unique ID
      const id = `direct-mermaid-${Date.now()}`;
      
      // Create a new div for the diagram
      const diagramDiv = document.createElement('div');
      diagramDiv.id = id;
      diagramDiv.style.width = '100%';
      diagramDiv.style.height = 'auto';
      
      // Append to container
      containerRef.current.appendChild(diagramDiv);
      
      console.log('DirectMermaidDiagram: Created div with ID:', id);
      
      // Render the diagram
      mermaid.render(id, chart).then(({ svg }) => {
        console.log('DirectMermaidDiagram: Render successful, SVG length:', svg.length);
        
        // Remove the temporary div
        if (diagramDiv.parentNode) {
          diagramDiv.parentNode.removeChild(diagramDiv);
        }
        
        // Create a new div for the SVG
        const svgContainer = document.createElement('div');
        svgContainer.innerHTML = svg;
        svgContainer.style.width = '100%';
        
        // Append the SVG to the main container
        containerRef.current.appendChild(svgContainer);
        
        console.log('DirectMermaidDiagram: SVG appended successfully');
        
      }).catch((err) => {
        console.error('DirectMermaidDiagram: Mermaid render failed:', err);
        console.error('DirectMermaidDiagram: Chart content:', chart);
        
        // Simply hide the diagram on error - don't show error to user
        containerRef.current.innerHTML = '';
      });

    } catch (err) {
      console.error('DirectMermaidDiagram: Unexpected error:', err);
      console.error('DirectMermaidDiagram: Chart content:', chart);
      
      // Simply hide the diagram on error - don't show error to user
      containerRef.current.innerHTML = '';
    }
  }, [chart, config]);

  if (!chart) return null;

  return (
    <DiagramContainer>
      <div ref={containerRef} style={{ width: '100%', minHeight: '150px' }} />
    </DiagramContainer>
  );
};

export default DirectMermaidDiagram;
